/**
 * The FountainForge mark.
 *
 * Two ideas in one silhouette: the fountain — a basin with water arcing out of
 * it — and the forge, the flame rising from its centre. Drawn as three bold
 * shapes rather than fine detail, because the smallest place it appears is 28px
 * in the header, where anything thinner than about 2 units disappears.
 *
 * Everything is `currentColor`, so it inherits the theme rather than pinning a
 * brand colour that would clash the moment the palette changes.
 */
export function Logo({ className = '', title }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? 'img' : 'presentation'}
      {...(title ? {} : { 'aria-hidden': true })}
    >
      {title && <title>{title}</title>}

      {/* Spray: water thrown out of the jet and falling back to the basin. */}
      <path
        d="M16 5.5C10.8 9 8 13 7.6 17.5"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        opacity="0.5"
      />
      <path
        d="M16 5.5c5.2 3.5 8 7.5 8.4 12"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        opacity="0.5"
      />

      {/* The forge flame, doubling as the fountain's central jet. */}
      <path
        d="M16 2.5c3.1 4.9 4.9 8 4.9 10.8a4.9 4.9 0 0 1-9.8 0c0-2.8 1.8-5.9 4.9-10.8Z"
        fill="currentColor"
      />

      {/* Basin. */}
      <path
        d="M3.5 19.5h25c0 6.4-5.6 10.5-12.5 10.5S3.5 25.9 3.5 19.5Z"
        fill="currentColor"
        opacity="0.85"
      />
    </svg>
  );
}
